export enum MigrateDex {
  RAYDIUM = "raydium",
  METEORA = "meteora",
  RAYDIUM_LAUNCHPAD = 'raydiumLaunchpad'
}

export enum EFinality {
  CONFIRMED = "confirmed",
  FINALIZED = "finalized"
}

export interface IMetadata {
  name: string
  symbol: string
  description: string
  file: File
  migrateDex: any,
  twitter?: string
  telegram?: string
  discord?: string
  website?: string
  createdOn?: string
}

export interface TxResult {
  txHash: string,
  latestBlockhash?: any
}

export interface TxResultBatch {
  txHash: string[],
  latestBlockhash?: any
}

